import React, { PureComponent } from 'react';
import { Segment, Label, Icon } from 'semantic-ui-react';

export class SelectedBox extends PureComponent {
  constructor(props) {
    super(props);
    this.state = {
      activityList: [],
    };
    this.renderSelectedTags = this.renderSelectedTags.bind(this);
  }

  renderSelectedTags() {
    return Object.values(this.state.activityList).map((activityData, i) => (
      <Label key={activityData.id}>{activityData.learnosity_activity_ref}</Label>
    ));
  }

  componentDidUpdate(prevProps, prevState) {
    if (!prevProps || prevProps.data !== this.props.data) {
      this.setState({
        activityList: this.props.data,
      });
    }
  }

  componentDidMount() {
    this.setState({
      activityList: this.props.data,
    });
  }

  render() {
    return <Segment>{this.renderSelectedTags()}</Segment>;
  }
}
